import { createSelector } from 'reselect';
import {
    get, has, filter, pick, values,
} from 'lodash';

/**
 * Base Selectors
 */
const getEntityId = (state, id) => id;
const getEntities = (state) => state.app.database.reservationCruises;
const getMetaEntities = (state) => state.app.metaDatabase.reservationCruises;
const getReservationCruiseNumbers = (state) => state.app.database.reservationCruiseNumbers;
const getCurrencies = (state) => state.app.database.currencies;
const getCabins = (state) => state.app.database.reservationCruiseCabins;

/**
 * Selector Builders
 */
export const buildMetaReservationCruiseSelector = () => createSelector([getEntityId, getMetaEntities], (entityId, metaEntities) =>
{
    if (has(metaEntities, entityId))
    {
        return metaEntities[entityId];
    }

    return {};
});

export const buildReservationCruiseSelector = () => createSelector([getEntityId, getEntities], (entityId, entities) =>
{
    if (has(entities, entityId))
    {
        return entities[entityId];
    }

    return {};
});

export const buildReservationCruisesSelector = () => createSelector([getEntityId, getEntities], (entityIds, entities) => values(pick(entities, entityIds)));

export const buildReservationCruisesByReservationIdSelector = () => createSelector([getEntityId, getEntities, getReservationCruiseNumbers, getCurrencies, getCabins], (reservationId, entities, reservationCruiseNumbers, currencies, cabins) => filter(entities, { reservation_id: reservationId }).map((reservationCruise) => ({
    ...reservationCruise,
    numbers: get(reservationCruiseNumbers, `ReservationCruise_${reservationCruise.id}_Numbers`, {}),
    currency: get(currencies, reservationCruise.currency_id, {}),
    cabins: filter(cabins, { reservation_cruise_id: reservationCruise.id }),
})));
